import { render } from "./AllReports.vue?vue&type=template&id=72ecbd2d&scoped=true"
import script from "./AllReports.vue?vue&type=script&lang=js"
export * from "./AllReports.vue?vue&type=script&lang=js"

import "./AllReports.vue?vue&type=style&index=0&id=72ecbd2d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72ecbd2d"]])

export default __exports__